import { Component, OnInit, ViewChild } from '@angular/core';
import { ApplicationTheme, IEventHandler } from '@lmnop/web-core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { ToggleButtonControl, OnToggleButtonChangeEventArgs } from '../toggle-button/toggle-button.control';
import { NgxSpinnerService } from 'ngx-spinner';

export class OnNightModeOnOffChangeEventArgs {
    constructor(theme: string) {
        this.theme = theme;
    }

    public theme: string;
}

@Component({
    selector: 'night-mode-on-off-control',
    templateUrl: 'night-mode-on-off.control.html',
    standalone: false,
})
export class NightModeOnOffControl extends ControlBase implements OnInit {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.onThemeChange = this.ioc.core.eventHandler;
    }
    public static THEME_CHANGED_EVENT: string = 'theme_changed';

    @ViewChild('nightModeToggleButton', { static: true })
    public nightModeToggleButton: ToggleButtonControl;

    public onThemeChange: IEventHandler;

    public ngOnInit(): void {
        this.nightModeToggleButton.initToggleButton(
            this.isDarklyMode(),
            'night_mode_on_off',
            (eventArgs: OnToggleButtonChangeEventArgs): void => {
                this.settings.applicationTheme = eventArgs.value ? ApplicationTheme.darkly : ApplicationTheme.flatly;
                this.settings.updateSettingsInStorage();
                this.onThemeChange.emit(
                    NightModeOnOffControl.THEME_CHANGED_EVENT,
                    new OnNightModeOnOffChangeEventArgs(this.settings.applicationTheme)
                );
            }
        );
    }

    private isDarklyMode(): boolean {
        return this.settings.applicationTheme === ApplicationTheme.darkly;
    }
}
